<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kjm7Pf/tc-custom/9781429978064.jpg?1720464481992" alt="This image is the cover for the book Doing Nothing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Doing Nothing
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of <i>Crying</i>, a witty, wide-ranging cultural history of our attitudes toward work—and getting out of it</b><br/><br/>Couch potatoes, goof-offs, freeloaders, good-for-nothings, loafers, and loungers: ever since the Industrial Revolution, when the work ethic as we know it was formed, there has been a chorus of slackers ridiculing and lampooning the pretensions of hardworking respectability. Reviled by many, heroes to others, these layabouts stretch and yawn while the rest of society worries and sweats. Whenever the world of labor changes in significant ways, the pulpits, politicians, and pedagogues ring with exhortations of the value of work, and the slackers answer with a strenuous call of their own: "To do nothing," as Oscar Wilde said, "is the most difficult thing in the world." From Benjamin Franklin's "air baths" to Jack Kerouac's "dharma bums," Generation-X slackers, and beyond, anti-work-ethic proponents have held a central place in modern culture.<br/><br/>Moving with verve and wit through a series of fascinating case studies that illuminate the changing place of leisure in the American republic, <i>Doing Nothing </i>revises the way we understand slackers and work itself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Lutz
      </h2>
      
      <p class="authorDescription body article"><P><B>Tom Lutz </B>'s previous books include <I>Crying: A Natural and Cultural History of Tears</I>; <I>American Nervousness, 1903: An Anecdotal History</I>; and<br><I>Cosmopolitan Vistas</I>. He lives in Los Angeles.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c037f62